import "@/assets/fonts-laoshibang/iconfont.css";
import "@/assets/fonts/iconfont.css";
// import '@/styles/element-variables.scss';
import "@/styles/index.scss"; // global css
// import '@tal/jy-element/packages/assets/css/index.scss';
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/icons"; // icon
// 埋点
import "@/utils/sensors";

import Vue from "vue";
import VueMeta from 'vue-meta';
import App from "./App";
import router from "./router";
import store from "./store";
import initMonitor from "@/utils/monitor";

// 配置 vue-meta
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

// 开启收集 vue2 框架报错
if (process.env.NODE_ENV !== "development") {
  const monitor = initMonitor();
  Vue.use(monitor.handleVueError());
}
Vue.use(ElementUI);
Vue.config.productionTip = false;
// 重写window.open 处理safari下无法新启弹窗的bug
// 如果需要获取window.open() 的返回值（即打开的新窗口的引用），注意需要异步获取
// https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari

const app = new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App)
});
export default app;
